import React from 'react';
import { getLandingIMessageHref, LANDING_CTA_TEXT } from './LandingConstants';
import LandingHeroCarousel from './LandingHeroCarousel';
import logoBlack from '../../../images/Logo/MrSea2025_logo_black.png';

const LandingHeroSection = () => {
  return (
    <section className="landing-hero">
      <div className="landing-hero__content">
        <img
          src={logoBlack}
          alt="Mr Sea Miami"
          className="landing-hero__logo"
        />
        <h1 className="landing-hero__headline">
          What's Stopping You From Your Best Day in Miami?
        </h1>
        <p className="landing-hero__subheadline">
          The Real Miami Boating Experience — We Handle the Boat, the Crew, the Vibes.
        </p>
      </div>
      <div className="landing-hero__support-image-wrapper">
        <LandingHeroCarousel />
      </div>
      <div className="landing-hero__cta-wrapper">
        <a
          href={getLandingIMessageHref()}
          className="landing-hero__cta"
          rel="noopener noreferrer"
        >
          {LANDING_CTA_TEXT}
        </a>
      </div>
    </section>
  );
};

export default LandingHeroSection;
